import ajax from '@/utils/ajax';

export const head = '/web';

// 查询教师对应产品信息
export const reqTeacherProduct = (teacherId) => ajax(`${head}/v1/product-teacher/${teacherId}`, '', 'GET');

// 查询教师详情
export const reqTeacherInfo = (teacherId) => ajax(`${head}/v1/teacher/select/detail?teacherId=${teacherId}`, '', 'GET');
